import { CopyToClipboard } from "react-copy-to-clipboard";
import { Button } from "@knowtex-ai/components";
import { Check, Copy } from "iconoir-react";
import type { PatientChatRequestKind } from "../../../lib/patientChat";

interface SmartAssistReplyActionsProps {
  reply: string;
  requestKind: PatientChatRequestKind | null;
  isIntervalHistoryReply: boolean;
  isReplyCopied: boolean;
  onCopied: () => void;
  /** Omit to hide "Use as note", e.g. when the note is locked. */
  onUseAsNote?: (reply: string) => void;
  /** Omit when the surface has no additional context to insert into. */
  onInsertAsAdditionalContext?: (reply: string) => void;
}

export default function SmartAssistReplyActions({
  reply,
  requestKind,
  isIntervalHistoryReply,
  isReplyCopied,
  onCopied,
  onUseAsNote,
  onInsertAsAdditionalContext,
}: SmartAssistReplyActionsProps) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      {isIntervalHistoryReply && onInsertAsAdditionalContext && (
        <Button
          type="button"
          variant="secondary"
          size="small"
          onClick={() => onInsertAsAdditionalContext(reply)}
        >
          Insert as additional context
        </Button>
      )}
      {!isIntervalHistoryReply && requestKind === "note_rewrite" && onUseAsNote && (
        <Button type="button" variant="secondary" size="small" onClick={() => onUseAsNote(reply)}>
          Use as note
        </Button>
      )}
      <CopyToClipboard text={reply} onCopy={onCopied}>
        <Button type="button" variant="secondary" size="small" icon={isReplyCopied ? Check : Copy}>
          {isReplyCopied ? <span className="text-success">Copied reply</span> : "Copy reply"}
        </Button>
      </CopyToClipboard>
    </div>
  );
}
